export { default as box } from './Box.svg';
export { default as gopro } from './Gopro.svg';
export { default as johnsonJohnson } from './Johnson_Johnson.svg';
export { default as lyft } from './Lyft.svg';
export { default as progressive } from './Progressive.svg';
export { default as solutionsMeta } from './Solutions_Meta.png';
